import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { linkBuilder } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { ButtonClean, ButtonPrimary } from 'front-end/src/components'
import Form, { FormRow } from '../../components/common/form/Form'
import Input from '../../components/common/form/input/Input'
import Label from '../../components/common/form/label/Label'
import { notification } from '../../components/common/notifications/Notifications'
import { Modal } from '../../components/common/modal/Modal'
import uniqueId from '../../components/utils/uniqueId'
import { useCreateSurveyMutation } from './CreateSurveyModal.codegen'

interface IProps {
  onHide: () => void
}

export const CreateSurveyModal = ({ onHide }: IProps) => {
  const [createSurvey, { loading }] = useCreateSurveyMutation()
  const [title, setTitle] = useState<string>('')
  const inputTitleId = uniqueId()

  return (
    <Form
      onSubmit={async () => {
        const { data } = await createSurvey({
          variables: { title }
        })
        if (data && data?.admin?.createSurvey?.id) {
          navigateTo(linkBuilder.surveyDetailManage(data.admin.createSurvey.id))
        } else {
          notification.error(t`Unable to create survey. Please try again.`)
        }
      }}
    >
      <Modal
        className="CreateSurveyModal"
        header={t`Create a new survey`}
        onHide={onHide}
        controls={[
          <ButtonClean key={1} onClick={onHide}>
            <Trans>Close</Trans>
          </ButtonClean>,
          <ButtonPrimary
            disabled={!title || loading}
            isLoading={loading}
            type={'submit'}
            key={2}
          >
            <Trans>Create</Trans>
          </ButtonPrimary>
        ]}
      >
        <FormRow>
          <Label htmlFor={inputTitleId}>
            <Trans>Survey name</Trans>:
          </Label>
          <Input
            autoFocus
            value={title}
            onChange={(val) => {
              setTitle(val)
            }}
            id={inputTitleId}
            fullWidth
          />
        </FormRow>
      </Modal>
    </Form>
  )
}
